import io from 'socket.io-client';
import App_data from "../views/config/App_data";

let socket = null;

export function connectSocket(token) {
    if (socket) {
        return socket;
    }

    console.log('===>> Connecting socket...');

    const apiEndpoint = App_data.backend_api;
    const mainApiEndpointHost = apiEndpoint.replace(/\/api$/, '');

    socket = io(mainApiEndpointHost, {
        path: '/socket.io',
        transports: ['websocket'],
        query: {
            token: token,
        },
        reconnection: true,
        forceNew: false,
    });

    socket.on('connect', function () {
        console.log('Socket connected:', socket.id);
    });

    socket.on('disconnect', function (reason) {
        console.log('Socket disconnected:', reason);
    });

    socket.on('connect_error', function (err) {
        console.error('------ Socket connect error:', err && err.message ? err.message : err);
    });

    return socket;
}

export function getSocket() {
    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}



// WEBPACK FOOTER //
// ./src/services/WebSocketService.js